export const proxyConfig = {
  ASSET_SERVICE,
  AUDIENCE_SERVICE,
  AUDIT_SERVICE,
  BIGIMPACT_SERVICE,
  CAMPAIGN_SERVICE,
  COMPANY_SERVICE,
  DOOH_SERVICE,
  DOOHESTIMATION_SERVICE,
  GEO_SERVICE,
  GEOISOLINE_SERVICE,
  PDF_SERVICE,
  POI_SERVICE,
  SEARCH_SERVICE,
  SHARE_SERVICE,
  STATS_SERVICE,
  USER_SERVICE
}

const API_GLOBAL = "https://api.kineticplatform.it"

function ASSET_SERVICE(ambience) {
  let apiUrl, apiVer
  switch(ambience){
    case "dev":
      apiUrl = "https://kinasset.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/asset-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/asset-service/"
      apiVer = "v1"
      break;
  }

  return {apiUrl, apiVer}
}


function AUDIENCE_SERVICE(ambience) {
  let apiUrl, apiVer

  switch(ambience){
    case "dev":
      apiUrl = "https://kinsearch.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/search-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/search-service/"
      apiVer = "v1"
      break;
  }

  return {apiUrl, apiVer}
}

function AUDIT_SERVICE(ambience) {
  let apiUrl, apiVer

  switch(ambience){
    case "dev":
      apiUrl = "https://kinaudit.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/audit-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/audit-service/"
      apiVer = "v1"
      break;
  }

  return {apiUrl, apiVer}
}

function BIGIMPACT_SERVICE(ambience) {
  let apiUrl, apiVer

  switch(ambience){
    case "dev":
      apiUrl = "https://kinsearch.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/search-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/search-service/"
      apiVer = "v1"
      break;
  }

  return {apiUrl, apiVer}
}

function CAMPAIGN_SERVICE(ambience) {
  let apiUrl, apiVer

  switch(ambience){
    case "dev":
      apiUrl = "https://kincampaign.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/campaign-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/campaign-service/"
      apiVer = "v1"
      break;
  }

  return {apiUrl, apiVer}
}

function COMPANY_SERVICE(ambience) {
  let apiUrl, apiVer

  switch(ambience){
    case "dev":
      apiUrl = "https://kincompany.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/company-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/company-service/"
      apiVer = "v1"
      break;
  }

  return {apiUrl, apiVer}
}

function DOOH_SERVICE(ambience) {
  let apiUrl, apiVer

  switch(ambience){
    case "dev":
      apiUrl = "https://kindooh.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/dooh-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/dooh-service/"
      apiVer = "v1"
      break;
  }

  return {apiUrl, apiVer}
}

function DOOHESTIMATION_SERVICE(ambience) {
  let apiUrl, apiVer

  switch(ambience){
    case "dev":
      apiUrl = "https://kindooh.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/dooh-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/dooh-service/"
      apiVer = "v1"
      break;
  }

  return {apiUrl, apiVer}
}

function GEO_SERVICE(ambience) {
  const apiKey = "AIzaSyDk2tsrjgOei53e0A5X8J7nFfj-MiDymIY"
  const apiGMaps = "https://maps.googleapis.com/maps/api/geocode/json"
  const apiArcGis = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer"

  let apiUrl, apiVer

  switch(ambience){
    case "dev":
      apiUrl = "https://kingeo.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/geo-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/geo-service/"
      apiVer = "v1"
      break;
  }

  return {apiUrl, apiVer, apiKey, apiGMaps, apiArcGis}
}

function GEOISOLINE_SERVICE() {
  const apiKeyGeoApify = "3a84d38e7df544f0937fc1dbca38615b"
  const apiGeoApify = "https://api.geoapify.com/v1/isoline"

  return {apiKeyGeoApify, apiGeoApify}
}

function PDF_SERVICE(ambience) {
  let apiUrl, apiVer

  switch(ambience){
    case "dev":
      apiUrl = "https://kinpdf.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/pdf-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/pdf-service/"
      apiVer = "v1"
      break;
  }

  return {apiUrl, apiVer}
}

function POI_SERVICE(ambience) {
  let apiUrl, apiVer

  switch(ambience){ 
    case "dev":
      apiUrl = "https://kinpoi.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/poi-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/poi-service/"
      apiVer = "v1"
      break;
    default:
  }

  return {apiUrl, apiVer}
}

function SEARCH_SERVICE(ambience) {
  let apiUrl, apiVer

  switch(ambience){
    case "dev":
      apiUrl = "https://kinsearch.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/search-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/search-service/"
      apiVer = "v1"
      break;
  }

  return {apiUrl, apiVer}
}

function SHARE_SERVICE(ambience) {
  let apiUrl, apiVer

  switch(ambience){
    case "dev":
      apiUrl = "https://kinshare.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/share-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/share-service/"
      apiVer = "v1"
      break;
    default:
  }

  return {apiUrl, apiVer}
}

function STATS_SERVICE(ambience) {
  let apiUrl, apiVer

  switch(ambience){
    case "dev":
      apiUrl = "https://kinstats.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/stats-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/stats-service/"
      apiVer = "v1"
      break;
  }

  return {apiUrl, apiVer}
}

function USER_SERVICE(ambience) {
  let apiUrl, apiVer

  switch(ambience){
    case "dev":
      apiUrl = "https://kinauth.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = API_GLOBAL + "/auth-service/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = API_GLOBAL + "/auth-service/"
      apiVer = "v1"
      break;
  }

  return {apiUrl, apiVer}
}

